import React, { useEffect, useState, useRef } from 'react';
import { useGlobalContext } from '../../js/context';
import anime from 'animejs/lib/anime.es.js';
import './LoadingPage.scss';
import ReactGA from 'react-ga4';

const LoadingPage = () => {
	const intervalTimeinSeconds = 10;
	const { changePageHandler } = useGlobalContext();
	const [intervals, setIntervals] = useState(0);
	const loadingTextRef = useRef();

	useEffect(() => {
		ReactGA.send({
			hitType: 'pageview',
			page: 'LoadingPage',
			title: 'LoadingPage',
		});
		const progress = (timeleft, timetotal) => {
			if (timeleft > 0) {
				setIntervals(Math.round(Math.abs((timeleft * 100) / timetotal - 100)));

				setTimeout(() => {
					progress(timeleft - 0.1, timetotal);
				}, 100);
			} else {
				setIntervals(100);
				changePageHandler('menu_page');
			}
		};

		progress(intervalTimeinSeconds, intervalTimeinSeconds);

		anime({
			targets: loadingTextRef.current,
			opacity: [0, 1],
			translateY: [80, 0],
		});
		//eslint-disable-next-line
	}, []);

	return (
		<div className='tos-loading'>
			<div className='tos-loader'></div>
			<span className='tos-loader__text'>Loading {intervals}%</span>

			<div
				className='tos-loading__text tos-hide-before-animated'
				ref={loadingTextRef}
			>
				<p>
					This interactive tool uses data generated by using the Health Canada
					Intense Testing Regime to compare the levels of harmful and
					potentially harmful constituents contained in the smoke of a reference
					cigarette (3R4F) with those found in the aerosol of our heated tobacco
					product.
				</p>
				<p>
					You will be able to view the machine-based average amount of harmful
					and potentially harmful constituents on a stick basis, allowing you to
					compare the difference between cigarettes and our heated tobacco
					product.
				</p>
			</div>
		</div>
	);
};

export default LoadingPage;
